module.exports = __webpack_public_path__ + "04.png?96b93a6e54384ae077602d685cd5f276";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/04.png
// module id = 119
// module chunks = 3